import styled from "@emotion/styled";
import { lightGrey2 } from "@stepfinance/react";

export const AssetCell = styled.div`
  display: flex;
  align-items: center;
`;

export const LendingBalanceCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const NetPositionCell = styled.div`
  display: flex;
  justify-content: flex-end;

  .step-popover-chip {
    margin-top: 3px;

    svg {
      path {
        fill: ${lightGrey2};
      }
    }
  }
`;
